module.exports = __webpack_public_path__ + "img/2021041920550164842i.de29ff77.png";